module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/id-card.svg?f45b0dc50e1dd35a3f1931ffa2ff45cd";